import React from 'react'
import Link from 'next/link';
import styles from './arrowbutton.module.scss'
import Arrow from '../icons/arrow';

function ArrowButton({link, text, color, textColor, type, openIn, round, bgColor, ...props}) {
  return (
    <div {...props}>
      {type === 'button' ? (
        <button className={`flex justify-center items-center ${styles.button}`}>
            <span className={`text relative ${round ? '' : styles.text}`} style={{color: textColor, '--color': textColor}}>{text}</span>
            <span 
            style={{backgroundColor: bgColor}}
            className={`flex items-center justify-center ${round && styles.iconRound} ${styles.icon}`}>
                <Arrow color={color} />
                <span 
                style={{borderColor: color}}
                className={styles.after}></span>
            </span>
        </button>
      ) : (
        <Link href={link} >
            <a className={`flex justify-center items-center ${styles.button}`} target={openIn}>
                <span className={`text relative ${round ? '' : styles.text}`} style={{color: textColor, '--color': textColor}}>{text}</span>
                <span 
                style={{backgroundColor: bgColor}}
                className={`flex items-center justify-center ${round && styles.iconRound} ${styles.icon}`}>
                    <Arrow color={color} />
                    <span 
                    style={{borderColor: color}}
                    className={styles.after}></span>
                </span>
            </a>
        </Link>
      ) }
    </div>
  )
}

export default ArrowButton